
import { Component, Vue, Watch } from "vue-property-decorator";
import CustomBtn from "@/components/CustomBtn.vue";
import { formRules } from "@/utils/formRules";

@Component({
    components: { CustomBtn },
})
export default class CustomerSuccessAddUserModal extends Vue {

    get isSearchValidEmail(): boolean {
        return formRules.isEmail(this.search);
    }

    get noResultsFound(): boolean {
        return !this.loading && !!this.search && this.users.length === 0;
    }

    private dialogModel: boolean = true;
    private search: string = "";
    private users: any[] = [];
    private selectedUser: any = null;
    private loading: boolean = false;
    private creating: boolean = false;
    private searchTimeout: any = null;
    private page: number = 1;
    private itemsPerPage: number = 10;
    private totalItems: number = 0;

    @Watch("search")
    public handlerSearch() {
        clearTimeout(this.searchTimeout);
        if (!this.search) {
            this.users = [];
            this.totalItems = 0;
            this.loading = false;
            return;
        }
        this.loading = true;
        this.searchTimeout = setTimeout(() => this.getFirstUsers(), 500);
    }

    @Watch("dialogModel")
    public handlerDialogModel(val: boolean) {
        if (!val) {
            this.$emit("close");
        }
    }

    private clearSelection(): void {
        this.selectedUser = null;
        this.search = "";
    }

    private getFirstUsers() {
        this.page = 1;
        this.users = [];
        return this.getUsers();
    }

    private getNextUsers() {
        this.page++;
        return this.getUsers();
    }

    private getUsers() {
        this.loading = true;
        return this.$store.dispatch("admin/users/getUsers", {
            query: { search: this.search, page: this.page, itemsPerPage: this.itemsPerPage },
        }).then((res) => {
            this.users = [...this.users, ...(res?.users || [])];
            this.totalItems = res?.count || 0;
        }).finally(() => {
            this.loading = false;
        });
    }

    private addUser() {
        if (!this.selectedUser) {
            return;
        }
        this.$store.dispatch("users/updateUser", {
            id: this.selectedUser.id,
            user: { isCustomerSuccess: true },
        }).then(() => {
            this.$emit("added");
            this.$emit("close");
        }).catch((error) => {
            this.$store.commit("alerts/displayHttpError", { error });
        }).finally(() => {
            this.$wait.end("customerSuccess/add-user");
        });
    }

    private createUser() {
        this.creating = true;
        this.$store.dispatch("admin/users/create", {
            email: this.search,
            isCustomerSuccess: true,
        }).then(() => {
            this.$emit("added");
            this.$emit("close");
        }).catch((error) => {
            this.$store.commit("alerts/displayHttpError", { error });
        }).finally(() => {
            this.creating = false;
        });
    }
}
